<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Select BM</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn v-if="!isAuditorRole" @click="buttonState.action" class="white--text" dark text>
              {{ buttonState.name }}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-alert dense type="error" v-if="showError">
              Please select BM Type
            </v-alert>
            <v-row>
              <v-col cols="12" sm="12">
                <v-radio-group
                  v-model="isSelectBM"
                  :row="!isSmallScreen"
                  @change="selectBM"
                >
                  <v-radio label="Bowel Movement" :value="true"></v-radio>
                  <v-radio label=" No Bowel Movement" :value="false"></v-radio>
                  <v-radio label="Absent" value="absent"></v-radio>
                </v-radio-group>
              </v-col>
              <div
                class="scroll-x"
                v-if="isSelectBM && isSelectBM !== 'absent'"
              >
                <v-card
                  v-for="(bistol, index) in bistols"
                  :key="index"
                  class="d-flex align-center ma-2 bistol-card"
                  :class="{ active: isActive(index) }"
                  dark
                  height="300"
                  width="250"
                  @click="toggleBM(index, bistol.type)"
                >
                  <v-row justify="center">
                    <img
                      class="pa-10 text-center"
                      :height="300"
                      :width="200"
                      :src="bistol.image"
                    />
                  </v-row>
                </v-card>
              </div>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    isAuditorRole: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      bistols: [
        {
          type: "Type 1",
          image: "/bm-type 1.png",
        },
        {
          type: "Type 2",
          image: "/bm-type 2.png",
        },
        {
          type: "Type 3",
          image: "/bm-type 3.png",
        },
        {
          type: "Type 4",
          image: "/bm-type 4.png",
        },
        {
          type: "Type 5",
          image: "/bm-type 5.png",
        },
        {
          type: "Type 6",
          image: "/bm-type 6.png",
        },
        {
          type: "Type 7",
          image: "/bm-type 7.png",
        },
      ],
      selectedType: null,
      isSelectBM: null,
      selectedBMType: "",
      showError: false,
      bmId: "",
      selectedOption: null,
    };
  },
  computed: {
    isActive() {
      return (index) => index === this.selectedType;
    },

    isSmallScreen() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    buttonState() {
      let state = "";
      if (this.bmId === "") {
        state = {
          name: "save",
          action: this.onSaveItem,
          color: "#259647",
        };
      } else {
        state = {
          name: "update",
          action: this.onSaveItem,
          color: "blue darken-1",
        };
      }
      return state;
    },
  },
  methods: {
    show() {
      this.dialog = !this.dialog;
    },
    toggleBM(index, bistol) {
      this.selectedType = index;
      this.selectedBMType = bistol;
    },
    selectBM() {
      if (this.isSelectBM && this.isSelecteBM === "absent")
        return (this.selectedType = null), (this.selectedBMType = "");
    },

    onSaveItem() {
      const isTypeExist = this.bistols.some(
        (bistol) => bistol.type === this.selectedBMType
      );

      this.selectedOption = [false, "absent"].includes(this.isSelectBM);

      if (!isTypeExist && !this.selectedOption) {
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 1000);
        return;
      }

      const data = {
        type:
          this.isSelectBM === "" || this.isSelectBM === "absent"
            ? ""
            : this.selectedBMType,
        isSelectBM: this.isSelectBM,
      };

      this.$emit(`${this.buttonState.name}-item`, data);
      this.show();
      this.close();
    },

    populateData(data) {
      console.log(data);
      this.bmId = data._id;
      this.isSelectBM =
        data.isSelectBM != "absent"
          ? this.convertStringToBoolean(data.isSelectBM)
          : data.isSelectBM;
      this.toggleBM(
        this.bistols.findIndex((obj) => obj.type === data.type),
        data.type
      );
    },
    clear() {
      this.selectedType = null;
      this.isSelectBM = null;
      this.selectedBMType = null;
      this.bmId = "";
    },
    close() {
      this.dialog = false;
      this.clear();
    },

    convertStringToBoolean(value) {
      if (value === "true") return true;
      if (value === "false") return false;
      return Boolean(value);
    },
  },
};
</script>

<style scoped>
.scroll-x {
  overflow-x: auto;
  white-space: nowrap;
  display: flex;
}

.bistol-card {
  background: rgb(202, 166, 193);
  background: linear-gradient(
    -180deg,
    rgba(202, 166, 193, 1) 0%,
    rgba(171, 114, 158, 1) 100%
  );
}

.bistol-card:hover {
  /* background: #e2d110; */
  cursor: pointer;
}

.active {
  background: #e2d110;
}
</style>
